import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import axios from "axios";
import qs from "qs";

function downloadForm(formPath, formType, formTitle,setIsLoading) {
    //console.log(formPath);
    setIsLoading(true);
    var data = qs.stringify({
        filePath: formPath,
        formTitle,
        formType,
    });
    var config = {
        method: "post",
        url: dataProvider.baseUrl + "forms-getFormDownloadUrl",
        headers: {
            token: authServices.getToken(),
            orgid: authServices.getOrgId(),
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: data,
    };

    axios(config)
        .then(function (response) {
            if (response.data.status == "success") {
                //console.log("FILE URL", response.data.data[0]);
                let url = response.data.data[0];
                let fileName = formTitle + ".docx";
                var a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                a.remove();
            }
            setIsLoading(false);
        })
        .catch(function (error) {
            console.error(error);
            setIsLoading(false);
        });
}

export default downloadForm ;